"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _allTemplates = require("../../../allTemplates.js");
var _DataConnectorsPicker = _interopRequireDefault(require("../../DataConnectorsPicker"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Settings = /*#__PURE__*/function (_React$Component) {
  _inherits(Settings, _React$Component);
  var _super = _createSuper(Settings);
  function Settings() {
    var _this;
    _classCallCheck(this, Settings);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_getChildren", function () {
      var id = _this.props.currentElement.id;
      var elements = _this.props.elements;
      if (!elements[id].children) {
        return [];
      }
      return elements[id].children.map(function (child) {
        return elements[child];
      });
    });
    return _this;
  }
  _createClass(Settings, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        elementTypes = _this$props.elementTypes,
        currentElement = _this$props.currentElement,
        updateCurrentElementSettings = _this$props.updateCurrentElementSettings,
        getDataConnectorMeta = _this$props.getDataConnectorMeta,
        currentPlayerTemplateName = _this$props.currentPlayerTemplateName,
        currentPlayerTemplateSettings = _this$props.currentPlayerTemplateSettings,
        dynamicUserLists = _this$props.dynamicUserLists,
        defaultValues = _this$props.defaultValues,
        showAdvancedSettings = _this$props.showAdvancedSettings,
        restrictionsLevel = _this$props.restrictionsLevel;
      if ((0, _isEmpty2["default"])(currentElement)) {
        return null;
      }
      var elementType = (0, _find2["default"])(elementTypes, {
        code: currentElement.type
      });
      var Builder = elementType ? elementType.builder : null;
      if (!elementType || !Builder) {
        return null;
      }
      var initialValues = _objectSpread(_objectSpread({}, elementType.builderInitialValues), currentElement.settings);
      var DataConnectorsPickerAdjusted = (0, _cccisdSurveyCommon.getComponentWithProps)(_DataConnectorsPicker["default"], {
        elementId: currentElement.id
      });
      var key = currentElement.id + '_' + currentElement.undoIterator;
      return /*#__PURE__*/_react["default"].createElement(Builder, {
        key: key,
        form: "builderForm_".concat(key),
        initialValues: initialValues,
        elementType: elementType,
        updatePreview: updateCurrentElementSettings,
        showPreviewError: function showPreviewError() {},
        availableTemplates: (0, _allTemplates.getTemplateList)('components', currentElement.type),
        availableComponentTemplates: (0, _allTemplates.getTemplatesForGroup)('components'),
        availablePlayerTemplates: (0, _allTemplates.getTemplateList)('players', 'flow'),
        currentPlayerTemplateName: currentPlayerTemplateName,
        currentPlayerTemplateSettings: currentPlayerTemplateSettings,
        children: this._getChildren(),
        DataConnectorsPicker: DataConnectorsPickerAdjusted,
        getDataConnectorMeta: getDataConnectorMeta,
        dynamicUserLists: dynamicUserLists,
        defaultValues: defaultValues,
        showAdvancedSettings: showAdvancedSettings,
        isTopLevel: currentElement.isTopLevel,
        restrictionsLevel: restrictionsLevel
      });
    }
  }]);
  return Settings;
}(_react["default"].Component);
exports["default"] = Settings;
_defineProperty(Settings, "propTypes", {
  elements: _propTypes["default"].object,
  elementTypes: _propTypes["default"].array,
  currentElement: _propTypes["default"].object,
  updateCurrentElementSettings: _propTypes["default"].func,
  getDataConnectorMeta: _propTypes["default"].func,
  currentPlayerTemplateName: _propTypes["default"].string,
  currentPlayerTemplateSettings: _propTypes["default"].object,
  dynamicUserLists: _propTypes["default"].array,
  defaultValues: _propTypes["default"].array,
  showAdvancedSettings: _propTypes["default"].bool,
  restrictionsLevel: _propTypes["default"].string
});